var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"donut",attrs:{"id":`donut-chart-${_vm.chartId}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }